import React, { useEffect, useState } from 'react';
import { getStations, createStation, updateStation } from '../lib/api';
import { MapPin, Plus, Edit2, Search, X } from 'lucide-react';

export default function StationsPage() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ station_name: '', state: '' });

  const load = () => {
    setLoading(true);
    getStations({ search }).then(r => { setData(r.data.stations || []); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, [search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editItem) { await updateStation(editItem._id, form); } else { await createStation(form); }
      setShowForm(false); setEditItem(null); setForm({ station_name: '', state: '' }); load();
    } catch (e) { alert(e.response?.data?.detail || 'Error'); }
  };

  return (
    <div className="space-y-4" data-testid="stations-page">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold text-boss-text">Station Master</h1><p className="text-boss-text-muted text-sm">{data.length} stations</p></div>
        <button onClick={() => { setShowForm(true); setEditItem(null); setForm({ station_name: '', state: '' }); }} className="flex items-center gap-2 px-4 py-2 bg-boss-violet text-white rounded-lg text-sm font-medium hover:bg-boss-violet-2" data-testid="add-station-btn"><Plus size={16} /> Add Station</button>
      </div>

      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-boss-text-muted" />
        <input type="text" placeholder="Search stations..." value={search} onChange={e => setSearch(e.target.value)} className="w-full pl-9 pr-4 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
      </div>

      {showForm && (
        <div className="bg-white rounded-xl p-6 shadow-sm border border-boss-border">
          <div className="flex items-center justify-between mb-4"><h3 className="font-semibold">{editItem ? 'Edit' : 'Add'} Station</h3><button onClick={() => setShowForm(false)}><X size={18} /></button></div>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input required placeholder="Station Name *" value={form.station_name} onChange={e => setForm(f => ({...f, station_name: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" data-testid="station-name-input" />
            <input placeholder="State" value={form.state} onChange={e => setForm(f => ({...f, state: e.target.value}))} className="px-3 py-2 rounded-lg border border-boss-border text-sm focus:ring-2 focus:ring-boss-violet/30 focus:outline-none" />
            <button type="submit" className="px-6 py-2 bg-boss-violet text-white rounded-lg text-sm font-medium hover:bg-boss-violet-2">{editItem ? 'Update' : 'Create'}</button>
          </form>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-boss-border overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b bg-boss-surface-2"><th className="text-left py-3 px-4 font-medium text-boss-text-muted">Station Name</th><th className="text-left py-3 px-4 font-medium text-boss-text-muted">State</th><th className="text-center py-3 px-4 font-medium text-boss-text-muted">Status</th><th className="text-center py-3 px-4 font-medium text-boss-text-muted">Action</th></tr></thead>
          <tbody>
            {loading ? [...Array(3)].map((_, i) => <tr key={i}><td colSpan={4} className="py-3 px-4"><div className="h-4 bg-boss-surface-3 rounded animate-pulse" /></td></tr>) : data.length === 0 ? (
              <tr><td colSpan={4} className="py-12 text-center text-boss-text-muted">No stations found</td></tr>
            ) : data.map(s => (
              <tr key={s._id} className="border-b border-boss-border/50 hover:bg-boss-surface-2/50">
                <td className="py-2.5 px-4 font-medium">{s.station_name}</td>
                <td className="py-2.5 px-4">{s.state || '---'}</td>
                <td className="py-2.5 px-4 text-center"><span className="inline-block px-2 py-0.5 rounded-full text-xs bg-green-100 text-green-700">Active</span></td>
                <td className="py-2.5 px-4 text-center"><button onClick={() => { setEditItem(s); setForm({ station_name: s.station_name, state: s.state || '' }); setShowForm(true); }} className="text-boss-violet hover:underline"><Edit2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
